// extracted by mini-css-extract-plugin
export var ArboretumMap = "ArboretumMap-module--ArboretumMap--c209b";
export var compass = "ArboretumMap-module--compass--27b7e";
export var key = "ArboretumMap-module--key--f36ad";
export var keyItem = "ArboretumMap-module--keyItem--1378e";
export var label = "ArboretumMap-module--label--74d3c";